import React from "react";
import { Stack } from "@mui/material";
import { motion } from "framer-motion";
import Img1 from "../section2Image.png";
import Img2 from "../logo121.png";
import { useMediaQuery } from "@mui/material";

const RevenueDetails = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <>
      {/* for desktop */}
      <Stack
        sx={{
          height: "auto",
          display: { sm: "flex", xs: "none" },
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          //border: "1px solid red",
        }}
      >
        <Stack
          sx={{
            fontSize: {
              xs: "15px",
              sm: "17px",
              md: "20px",
            },
            lineHeight: { xs: 1.5, sm: 1.80, md: 1.2 },
            fontFamily: "'Roboto', sans-serif",
            fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
            alignItems: "flex-start",
            width: {
              xs: "92%",
              sm: "84%",
              md: "90%",
              lg: "84%",
              xl: "70%",
            },
            // textAlign: "left",
            marginTop: {
              xs: "20px",
              sm: "80px",
              md: "80px",
              lg: "80px",
              xl: "35px",
            },
            marginBottom: {
              xs: "20px",
              sm: "40px",
              md: "40px",
              lg: "40px",
              xl: "40px",
            },
            color: "text.secondary",
            // border: "1px solid white",
            // ,1F85C0 , 53AFE4
            marginLeft: { xl: "0px", lg: "40px", sm: "0px" },
          }}
        >
          <span>
            Website's often feel clunky, with slow support, high costs and
            fragmented communication. In contrast, WhatsApp offers a faster,
            simpler and more cost-effective solution-enabling real-time
            chats, smart automation and interactive buttons within one familiar
            app. No learning curve, no clutter- just instant,
            personalized service.
          </span>
        </Stack>
        {/* <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: {
              xs: "95%",
              sm: "84%",
              md: "60%",
              lg: "60%",
              xl: "60%",
            },
            marginBottom: {
              xs: "24px",
              sm: "80px",
              md: "80px",
              lg: "80px",
              xl: "80px",
            },
            height: "96px",
            paddingLeft: {
              xs: "0px",
              sm: "0px",
              md: "40px",
              lg: "0px",
              xl: "0px",
            },
            // border: "1px solid white",
          }}
        >
       
          <Stack
            sx={{
              height: "96px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: { xl: "0px", lg: "40px", sm: "0px" },
              // border: "2px solid green",
            }}
          >
            <img
              src={Img2}
              alt="logo"
              style={{
                height: "72px",
                width: "72px",
                marginLeft: "20px",
                marginRight: "20px",
                borderRadius: "8px",
              }}
            />
          </Stack>

          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              height: {
                xs: "96px",
                sm: "96px",
                md: "96px",
                lg: "48px",
                xl: "48px",
              },
              width: {
                xs: "120px",
                sm: "180px",
                md: "180px",
                lg: "210px",
                xl: "210px",
              },
              justifyContent: "center",
              // border: "2px solid green",
            }}
          >
            <Stack
              sx={{
                fontSize: { lg: "18px", xl: "18px" },
                fontWeight: 600,
                marginBottom: "8px",
                color: "rgb(5 78 146)",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Abinash Mishra
            </Stack>
            <Stack
              sx={{
                fontSize: { lg: "16px", xl: "16px" },
                fontWeight: 600,
                color: "rgb(5 78 146)",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Collector
            </Stack>
          </Stack>
        </Stack> */}
      </Stack>

      {/* for mobile */}

      <Stack
        sx={{
          height: "auto",
          display: { sm: "none", xs: "flex" },
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          //border: "1px solid red",
        }}
      >
        <Stack
          sx={{
            fontSize: {
              xs: "16px",
              sm: "18px",
              md: "24px",
              lg: "36px",
              xl: "24px",
            },
            lineHeight: {
              xs: "22px",
              sm: "28px",
              md: "36px",
              lg: "52px",
              xl: "40px",
            },
            fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
            color: "#333",
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
            alignItems: "flex-start",
            width: {
              xs: "92%",
              sm: "84%",
              md: "90%",
              lg: "84%",
              xl: "70%",
            },
            textAlign: "left",
            marginTop: {
              xs: "20px",
              sm: "80px",
              md: "80px",
              lg: "80px",
              xl: "35px",
            },
            marginBottom: {
              xs: "20px",
              sm: "40px",
              md: "40px",
              lg: "40px",
              xl: "40px",
            },
            color: "#333",
            fontFamily: "'Roboto', sans-serif",
            // border: "1px solid white",
            // ,1F85C0 , 53AFE4
            marginLeft: { sm: "0", xs: "8px" }
          }}
        >
          <span>
            Websites are complex and slow. WhatsApp offers instant, simple and automated chat-based service- all in one familiar app.
          </span>
        </Stack>
        {/* <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: {
              xs: "95%",
              sm: "84%",
              md: "60%",
              lg: "60%",
              xl: "60%",
            },
            marginBottom: {
              xs: "24px",
              sm: "80px",
              md: "80px",
              lg: "80px",
              xl: "80px",
            },
            height: "96px",
            paddingLeft: {
              xs: "0px",
              sm: "0px",
              md: "40px",
              lg: "0px",
              xl: "0px",
            },
            // border: "1px solid white",
          }}
        >
       
          <Stack
            sx={{
              height: "96px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: { xl: "0px", lg: "40px", sm: "0px" },
              // border: "2px solid green",
            }}
          >
            <img
              src={Img2}
              alt="logo"
              style={{
                height: "72px",
                width: "72px",
                marginLeft: "20px",
                marginRight: "20px",
                borderRadius: "8px",
              }}
            />
          </Stack>

          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              height: {
                xs: "96px",
                sm: "96px",
                md: "96px",
                lg: "48px",
                xl: "48px",
              },
              width: {
                xs: "120px",
                sm: "180px",
                md: "180px",
                lg: "210px",
                xl: "210px",
              },
              justifyContent: "center",
              // border: "2px solid green",
            }}
          >
            <Stack
              sx={{
                fontSize: { lg: "18px", xl: "18px" },
                fontWeight: 600,
                marginBottom: "8px",
                color: "rgb(5 78 146)",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Abinash Mishra
            </Stack>
            <Stack
              sx={{
                fontSize: { lg: "16px", xl: "16px" },
                fontWeight: 600,
                color: "rgb(5 78 146)",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Collector
            </Stack>
          </Stack>
        </Stack> */}
      </Stack>
      {/* </motion.div> */}
    </>
  );
};

export default RevenueDetails;
